<template>
  <div class="membership" :class="[ getTerminalForChrome() ? 'membership-mo': 'membership-pc']">
    <div class="list">
      <div class="list-item" v-for="(v, i) in list" :key="i" @click="toDetail(v)">
        <div class="first-item" v-if="i === 0">
          <div class="left" :style="{backgroundColor: !v.thumbUrl ? '#f6f6f6' : 'fff'}">
            <!-- <img :src="v.thumbUrl || defaultImg" alt /> -->
            <img v-if="v.thumbUrl" :src="v.thumbUrl" alt />
          </div>
          <div class="right">
            <div class="title" :style="{fontWeight: v.wider === '1' ? 'bold' : 'normal', color: v.tored === '1' ? 'red' : '#31a087'}">{{v.caucustitle}}</div>
            <div class="desc">{{v.description}}</div>
            <div class="date">[{{v.rec_createdtime_str}}]</div>
          </div>
        </div>
        <div class="second-item" v-else>
          <div class="left">{{v.rec_createdtime_str | changeDate}}</div>
          <div class="right">
            <div class="title" :style="{fontWeight: v.wider === '1' ? 'bold' : 'normal', color: v.tored === '1' ? 'red' : '#333'}">{{v.caucustitle}}</div>
            <div class="desc">{{v.description}}</div>
          </div>
        </div>
      </div>
    </div>
    <Page :total="total" show-total @on-change="pageChange" style="text-align: center"></Page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fetchCaucus } from '@/api/school';
import bus from './common/bus';
export default {
  data() {
    return {
      params: {
        pageNumber: 1,
        pageSize: 10,
        category: this.$route.query.id
      },
      total: 0,
      list: [],
      defaultImg: require('../../assets/default.jpeg')
    };
  },
  filters: {
    changeDate(val) {
      if (val) {
        const arr = val.split('-');
        return `${arr[1]}-${arr[2]}`;
      } else {
        return '';
      }
    }
  },
  watch: {
    '$route.query': function(val) {
      this.params.category = val.id;
      this._fetchCaucus();
    }
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toDetail(val) {
      // bus.detailContent = val
      // sessionStorage.setItem('detailMsg', JSON.stringify(val))
      this.$router.push({
        path: `/detail?categorybelong=${val.categorybelong}&rec_id=${val.rec_id}`
      });
    },
    pageChange(val) {
      this.params.pageNumber = val;
      this._fetchCaucus();
    },
    _fetchCaucus() {
      fetchCaucus({ ...this.params }).then(res => {
        if (res.status === 200) {
          this.list = res.data.data;
          this.total = res.data.totalCount;
        }
      });
    }
  },
  mounted() {
    this._fetchCaucus();
  }
};
</script>

<style scoped lang="scss">
.membership-pc {
  padding: 32px 0px;
  .list {
    margin-bottom: 10px;
    .list-item {
      cursor: pointer;
      &:hover {
        box-shadow: 0 3px 12px rgba(10,16,20,.24),0 3px 12px rgba(10,16,20,.12);
      }
      .first-item {
        display: flex;
        padding: 20px;
        .left {
          width: 348px;
          height: 252px;
          margin-right: 40px;
          transition: transform .3s;
          &:hover {
            transform: scale(1.1);
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            vertical-align: middle;
          }
        }
        .right {
          flex: 1;
          .title {
            font-size: 28px;
            color: #31a087;
            cursor: pointer;
            transition: all .3s;
            &:hover {
              // font-size: 32px;
            }
          }
          .desc {
            margin-top: 15px;
            margin-bottom: 12px;
            font-size: 18px;
            color: #333333;
          }
          .date {
            font-size: 16px;
            color: #999;
          }
        }
      }
      .second-item {
        // width: 1440px;
        height: 146px;
        display: flex;
        align-items: center;
        // border-bottom: 1px dashed #d2d2d2;
        .left {
          width: 146px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          color: #31a087;
          margin-right: 28px;
        }
        .right {
          width: calc(100% - 146px - 28px);
          .title {
            font-size: 28px;
            color: #333333;
            margin-bottom: 16px;
            cursor: pointer;
            transition: all .3s;
            &:hover {
              // font-size: 32px;
            }
          }
          .desc {
            width: 100%;
            font-size: 18px;
            color: #999999;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
.membership-mo {
  padding: 6.93vw 2.67vw;
  .list {
    margin-bottom: 2.13vw;
    .list-item {
      padding: 4.27vw 0vw;
      border-bottom: 0.3vw dashed #d2d2d2;
      .first-item {
        .left {
          width: 100%;
          color: #999;
          img {
            display: inline-block;
            width: 100%;
          }
        }
        .right {
          .title {
            font-size: 4vw;
            color: #31a087;
          }
          .desc {
            margin: 2.13vw 0vw;
          }
          .date {
            font-size: 3.2vw;
            color: #999;
          }
        }
      }
      .second-item {
        display: flex;
        align-items: center;
        .left {
          width: 12.8vw;
          font-size: 4vw;
          color: #333333;
        }
        .right {
          width: calc(100% - 12.8vw);
          .title {
            font-size: 4vw;
            color: #333333;
            margin-bottom: 2.13vw;
          }
          .desc {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 3.2vw;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
